import script from "./Balance.vue?vue&type=script&setup=true&lang=js"
export * from "./Balance.vue?vue&type=script&setup=true&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=b61a85bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b61a85bc"]])

export default __exports__